import React, {
    createElement,
    createRef,
    DetailedHTMLProps,
    HTMLAttributes, useEffect,
    useLayoutEffect, useRef, useState,
} from "react";


type TypedProps = {
    text: string;
    speed: number;
} & Omit<DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>, 'options'>;

let prevText = "";

let timeOut: NodeJS.Timeout | null = null;

const TypedWrapper = (props: TypedProps) => {

    const ref = useRef<HTMLElement>();

    //const [currentText, setCurrentText] = useState<string>("");

    const appendText = (txt: string) =>{
        if(ref.current){
            ref.current.innerHTML += txt;
        }
    }
    //const [currentTextIndex, setCurrentTextIndex] = useState<number>(0);


    useEffect(() => {

        if (!ref.current) {
            return;
        }

        if(prevText == props.text){
            return;
        }else{
            if(ref.current){
                ref.current.innerHTML = "";
            }
        }

        prevText = props.text;

        const textToType = props.text;

        const fn = (index: number) => {
            if(textToType.charAt(index) == '\\' && textToType.charAt(index+1) == 'n'){
                appendText("<br/>");
            }else{
                appendText(textToType.charAt(index));
            }
            if(index == textToType.length - 1){
                return;
            }
            timeOut = setTimeout(() => fn(index + 1), props.speed + (100 * Math.random()));
        };

        fn(0);
        //currentTextIndex++;
        //setCurrentTextIndex(i => i + 1);

        return () => {
            // if(timeOut){
            //     clearTimeout(timeOut);
            // }
        }

    }, [ref, props.text, props.speed, prevText]);

    const typedStyle = {...props.style, position: "absolute", top: "0", whiteSpace: 'pre-line'}

    return <div style={{position: "relative"}}>
        <div {...{className: props.className, style: {...props.style, whiteSpace: 'pre-line', opacity: 0}}}>{props.text}</div>
        <div {...props as any} ref={ref as any} {...{style: {...typedStyle}}} />
    </div>;
};

export default TypedWrapper;